import { OclDecisionService } from 'src/app/ocl/services/ocl-decision-service/ocl-decision.service';
import { FltDecision } from '../../../flt/models/flt-decision';
import { FltApplicability } from '../../../flt/models/flt-applicability';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CommonStoreManager } from '../../../common/store/common.store-manager';
import { OCL_EVENT_MODAL_TOKEN } from '../ocl-event-modal/ocl-event-modal-tokens';
import { HolContext } from '../../../common/models/hol-context.model';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HolNotification, HolNotifyFunction } from '../../../common/models/hol-notification.model';
import { TranslatePipe } from '../../../common/pipes/translate/translate.pipe';
import * as moment from 'moment';
import { OclEvent } from '../../models/ocl-event.model';
import { OCL_LOGBOOK_MODAL_TOKEN } from '../ocl-logbook-modal/ocl-logbook-modal.token';
import { OclLinkedItemsStoreManager } from '../../store/linked-items/ocl-linked-items-store-manager.service';
import { OclDecision } from '../../models/ocl-decision.model';
import { OclNotificationsService } from '../../services/ocl-notifications-service/ocl-notifications.service';
import { OclDecisionsStoreManager } from '../../store/decisions/ocl-decisions.store-manager';
import { ModuleConfigService } from '../../../common/services/module-config/module-config.service';
import { OclLinksService } from '../../services/ocl-links-service/ocl-links.service';
import { FltFlightService } from '../../../flt/services/flt-flight.service';
import { nextInfoType } from '../../../common/components/hol-next-info/hol-next-info.component';
import { ConfirmationModalComponent } from '../../../common/modals/confirmation-modal/confirmation-modal.component';
import { intersectionWith, cloneDeep, difference } from 'lodash';
import { HolObject } from '../../../common/models/hol-object';
import { OclDecisionGroup } from '../../models/ocl-decision-group.model';
import { OclGroupsStoreManager } from '../../store/groups/ocl-groups.store-manager';
import { OclGroupService } from '../../services/ocl-group-service/ocl-group.service';
import { OclLogbookDecisionService } from '../../services/ocl-logbook-decision-service/ocl-logbook-decision.service';
import { OclOptionsService } from '../../services/ocl-options-service/ocl-options.service';
import { HolModalConfig } from '../../../common/modals/hol-modal/config/HolModalConfig';
import { take } from 'rxjs/operators';
import { HolOptionsService } from '../../../common/services/hol-options.service';
import { Internal } from '../../models/ocl-interface.model';

@Component({
  selector: 'app-ocl-decisions-modal',
  templateUrl: './ocl-decisions-modal.component.html',
  styleUrls: ['./ocl-decisions-modal.component.scss'],
})
export class OclDecisionsModalComponent implements OnInit, OnDestroy, Internal {
  public decision: OclDecision = new OclDecision();
  public isCreate: boolean;
  public isReadOnly: boolean;
  public hasErpAccess: boolean;
  public hasToSendSMS = false;
  public events: OclEvent[] = null;
  public selectedItem = undefined;
  public selectedTags = [];
  public module: string;
  public action: string;
  public isUtc: boolean;
  public isPinned = false;
  public loading = false;
  public loadingFlight = false;
  public selectedFlight = undefined;
  public searchText: string;
  public notifications: HolNotification[];
  public logBookItems: any[] = [];
  public linkedLogBooks: string[];
  public linkedLogBooksDisplay: any[] = [];
  public linkedLogBooksCopy: string[] = [];
  public linkedEvents: string[];
  public linkedEventsDisplay: any[] = [];
  public linkedEventsCopy: string[] = [];
  public linkedEventsArchived = [];
  public linkedLogBookArchived = [];
  public decisionGroup: OclDecisionGroup[] = [];
  public linkedGroup: string[] = [];
  public isFromLogBook = false;
  public searchData = {
    date: undefined,
    flights: [],
    flightsFiltered: [],
    flightNumber: null,
  };
  public autocompletePlaceHolder: string;
  public disabledLinks = {};
  modeLinkIsActivate: boolean;
  public airportsCode: Array<string>;
  public applicabilityIsReadOnly: boolean;
  public context: HolContext;
  isHistory;
  nextInfo: nextInfoType = {
    nextInfoTime: undefined,
    nextInfoDone: false,
  };
  public fromERP = false;
  public hasCrisisInProgress = false;
  public toERP = false;
  public changeToLogbook = false;
  public hasCrisisInProgressSub: Subscription;
  public duplicateToOtherModule = false;
  public oldDuplicateToOtherModuleValue = null;
  public newDuplicateToOtherModuleValue = null;
  public updateDuplicateToOtherModuleFlightValue = false;
  public isTodoConfigActivated = false;
  public isInSummary = false;
  public isInBriefing = false;
  public config: HolModalConfig;
  public config$: BehaviorSubject<HolModalConfig>;
  private initialNIvalue = null;
  private initialNIdone = null;
  public isPrivate = false;

  constructor(
    protected dialog: MatDialog,
    protected translatePipe: TranslatePipe,
    public moduleConfig: ModuleConfigService,
    public flightService: FltFlightService,
    protected notificationsService: OclNotificationsService,
    protected dialogRef: MatDialogRef<OclDecisionsModalComponent>,
    protected linksService: OclLinksService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected decisionsService: OclDecisionService,
    @Inject(OCL_LOGBOOK_MODAL_TOKEN) protected occLogbookModal,
    protected occLinkItemsStoreManager: OclLinkedItemsStoreManager,
    protected occDecisionsStoreManager: OclDecisionsStoreManager,
    @Inject(OCL_EVENT_MODAL_TOKEN) protected eventModal,
    protected commonStoreManager: CommonStoreManager,
    @Inject('$rootScope') public $rootScope,
    protected groupStoreManager: OclGroupsStoreManager,
    protected groupService: OclGroupService,
    protected oclLogbookDecisionService: OclLogbookDecisionService,
    protected oclOptions: OclOptionsService,
    protected holOptionsService: HolOptionsService,
  ) {
    this.notificationsService.getAll().then(notif => (this.notifications = notif));
    this.hasErpAccess = $rootScope.accessRights.crisis !== 'UNAUTHORIZED';
    this.isTodoConfigActivated = this.moduleConfig.config.activateTODO;
  }

  get limitTo(): HolObject | undefined {
    return undefined;
  }

  async ngOnInit(): Promise<void> {
    this.module = this.translatePipe.transform('PDF_TITLE.OCC');
    this.action = this.translatePipe.transform('PDF_TITLE.DECISION');
    this.autocompletePlaceHolder = this.translatePipe.transform(
      this.moduleConfig.config.translateKey + '.DASHBOARD.STATUS_DECISIONS.MODALS.PLACEHOLDER_CHOOSE_DATE',
    );

    this.isUtc = this.data.isUtc;
    this.modeLinkIsActivate = this.data.modeLinkIsActivate;

    this.events = cloneDeep(this.data.events) || [];
    this.logBookItems = cloneDeep(this.data.logBookItems) || [];

    this.airportsCode = this.data.airportsCode;

    this.isHistory = this.data.isHistory ? this.data.isHistory : false;

    this.hasCrisisInProgressSub = this.commonStoreManager.crisis.subscribe(crisis => {
      if (crisis) this.hasCrisisInProgress = crisis.inProgress;
    });

    this.config = new HolModalConfig();

    if (this.data.decision) {
      this.initLinks();
      this.isReadOnly = this.data.isReadOnly || this.isHistory || this.data.decision.fromERP;
      this.isCreate = false;
      this.isInSummary =
        this.data.decision &&
        this.data.decision.summary &&
        this.data.decision.summary.decision &&
        this.data.decision.summary.decision.objectId !== undefined;
      if (this.isInSummary) {
        this.isInBriefing = this.data.decision.summary.isDisplayInBriefing;
      }
      this.applicabilityIsReadOnly = true;
      this.decision = this.data.decision;
      if (this.decision.flight) {
        this.selectedFlight = this.decision.flight;
        this.initSearchDataFlight();
      }
      if (this.isTodoConfigActivated && this.data.decision.isTodo) {
        this.initialNIvalue = this.decision.nextInfoTime;
        this.initialNIdone = this.decision.done;
      }
      this.nextInfo = {
        nextInfoTime: this.decision.nextInfoTime,
        nextInfoDone: this.decision.done,
      };

      this.config.haveGroup = this.linkedGroup.length > 0;
      this.config.item = this.decision;
      this.config.limitTo = this.limitTo;
      this.config.canArchive = false;
      this.config.canEditTitle = !this.isHistory;
      // this.config.canUpdateFromOtherModule = this.canUpdateFromOtherModule;
      this.config.contentTextLength = 200; // <= TODO mettre la valeur HolOptions
      this.config.context = this.context;
      this.config.type = 'DECISION';
      this.config.notifications = this.notifications;
      this.config.isReadOnly = this.isReadOnly || this.isHistory;
      this.config.isHistory = this.isHistory;
      this.config.isCreate = false;
      this.config.nextInfo = this.nextInfo;
      this.config.historyItemComponent = this.data.itemComponent;
      this.config.historyItemListMode = true;
      this.config.historyItemObjectId = this.decision.objectId;
      this.config.historyItemType = 'decision';
      this.config.historyTitle = this.moduleConfig.config.translateKey + '.MODALS.HISTORY.DECISION';
    } else {
      this.decision.isPinned = false;
      this.decision.done = false;
      this.decision.attachments = {};
      this.decision.contentText = '';
      this.isCreate = true;
      this.applicabilityIsReadOnly = false;
      this.linkedEvents = [];
      this.linkedLogBooks = [];
      if (this.data.fromLogBook) {
        this.isFromLogBook = true;
        this.decision.contentText = this.data.fromLogBook.message;
        this.decision.tags = cloneDeep(this.data.fromLogBook.tags);
        this.decision.attachments = cloneDeep(this.data.fromLogBook.attachments);
        this.decision.acl = this.data.fromLogBook.acl;
        if (this.data.fromLogBook.flight && this.data.fromLogBook.flight.flightNumber) {
          this.selectedFlight = this.data.fromLogBook.flight;
          this.initSearchDataFlight();
        }
      }

      this.config.isCreate = true;
      this.config.haveGroup = false;
      this.config.item = this.decision;
      this.config.limitTo = this.limitTo;
      this.config.canArchive = false;
      this.config.canEditTitle = !this.isHistory;
      // this.config.canUpdateFromOtherModule = this.canUpdateFromOtherModule;
      this.config.contentTextLength = 200; // <= TODO mettre la valeur HolOptions
      this.config.type = 'DECISION';
      this.config.notifications = this.notifications;
      this.config.isReadOnly = this.isReadOnly || this.isHistory;
      this.config.isHistory = this.isHistory;
      this.config.isCreate = true;
      this.config.nextInfo = this.nextInfo;
    }

    if (this.decision.fromERP) {
      this.fromERP = this.decision.fromERP ? true : false;
    }

    if (this.moduleConfig.config.displayToERP) {
      this.toERP = this.decision.toERP ? true : false;
    }

    this.context = {
      module: this.moduleConfig.config.translateKey,
      category: 'DECISION',
      htmlTitle: this.decision.contentText,
      htmlDate: this.decision.createdAt ? this.decision.createdAt : '',
      htmlTemplate: 'A',
    };
    this.config.context = this.context;

    // Groups
    this.groupStoreManager.groupsState.subscribe(g => {
      this.decisionGroup = g.decisions;
    });

    const g = await this.groupStoreManager.groupsState.pipe(take(1)).toPromise();
    this.decisionGroup = g.decisions;

    this.config$ = new BehaviorSubject<HolModalConfig>(this.config);
    this.loading = false;

    this.config.haveGroup = this.linkedGroup.length > 0;
  }

  public initSearchDataFlight(): void {
    this.searchData.flightNumber = this.selectedFlight.flightNumber;
    this.searchData.date = moment.utc(this.selectedFlight.sta).toDate();
    // tslint:disable-next-line: max-line-length
    const date = moment.utc(
      `${this.searchData.date.getFullYear()}/${this.searchData.date.getMonth() + 1}/${this.searchData.date.getDate()}`,
      'YYYY/MM/DD',
    );
    this.flightService.getBySlot(date).then(res => {
      this.searchData.flights = res;
      this.searchData.flightsFiltered = res;
    });
  }

  public async initLinks(): Promise<void> {
    await this.linksService.getLinkDecisionEventById(this.data.decision.objectId).then(evts => {
      this.linkedEvents = [];
      if (!evts) {
        return;
      }
      evts.forEach(evt => {
        if (this.events.findIndex(el => el.objectId === evt.objectId) === -1) {
          this.disabledLinks[evt.objectId] = true;
          this.linkedEventsArchived.push(evt);
        } else {
          this.linkedEvents.push(evt.objectId);
          this.linkedEventsCopy.push(evt.objectId);
        }
        this.linkedEventsDisplay.push(evt);
      });
      if (this.data.decision.event && evts.findIndex(el => el === this.data.decision.event.objectId) === -1) {
        this.linkedEvents.push(this.data.decision.event.objectId);
        this.linkedEventsCopy.push(this.data.decision.event.objectId);
        this.linkedEventsDisplay.push(this.data.decision.event);
      }
      if (this.config.haveEventLink && this.linkedEvents.length === 0) {
        this.config.haveEventLink = false;
        //  this.config$.next(this.config);
      } else if (!this.config.haveEventLink && this.linkedEvents.length > 0) {
        this.config.haveEventLink = true;
        //  this.config$.next(this.config);
      }
    });
    await this.linksService.getLinkLogBookForDecisionById(this.data.decision.objectId).then(lgks => {
      if (!lgks) {
        this.linkedLogBooks = [];
        return;
      }
      this.linkedLogBooks = [];
      lgks.forEach(lgk => {
        if (this.logBookItems.findIndex(el => el.objectId === lgk.objectId) === -1) {
          this.disabledLinks[lgk.objectId] = true;
          this.linkedLogBookArchived.push(lgk);
        } else {
          this.linkedLogBooks.push(lgk.objectId);
          this.linkedLogBooksCopy.push(lgk.objectId);
        }
        this.linkedLogBooksDisplay.push(lgk);

        if (this.config.haveLogbookLink && this.linkedLogBooksDisplay.length === 0) {
          this.config.haveLogbookLink = false;
          //  this.config$.next(this.config);
        } else if (!this.config.haveLogbookLink && this.linkedLogBooksDisplay.length > 0) {
          this.config.haveLogbookLink = true;
          //  this.config$.next(this.config);
        }
      });
    });

    if (this.config$) {
      this.config$.next(this.config);
    }
  }

  public changeDate(event): void {
    this.searchData.date = new Date(event);
    if (!this.searchData.date) {
      this.selectedFlight = undefined;
      this.searchText = undefined;
      this.selectedFlight = undefined;
      this.searchData.flights = [];
      this.autocompletePlaceHolder = this.translatePipe.transform(
        this.moduleConfig.config.translateKey + '.DASHBOARD.STATUS_DECISIONS.MODALS.PLACEHOLDER_CHOOSE_DATE',
      );
      return;
    }
    this.searchText = undefined;
    this.selectedFlight = undefined;
    this.searchData.flights = [];
    this.autocompletePlaceHolder = this.translatePipe.transform(
      this.moduleConfig.config.translateKey + '.DASHBOARD.STATUS_DECISIONS.MODALS.PLACEHOLDER_FLIGHT_LOADING',
    );
    // tslint:disable-next-line: max-line-length
    const date = moment.utc(
      `${this.searchData.date.getFullYear()}/${this.searchData.date.getMonth() + 1}/${this.searchData.date.getDate()}`,
      'YYYY/MM/DD',
    );
    this.flightService.getBySlot(date).then(res => {
      this.searchData.flights = res;
      this.searchData.flightsFiltered = res;
      if (!res.length) {
        this.autocompletePlaceHolder = this.translatePipe.transform(
          this.moduleConfig.config.translateKey + '.DASHBOARD.STATUS_DECISIONS.MODALS.PLACEHOLDER_NO_FLIGHT_FOUND',
        );
      } else {
        this.autocompletePlaceHolder = this.translatePipe.transform(
          this.moduleConfig.config.translateKey + '.DASHBOARD.STATUS_DECISIONS.MODALS.PLACEHOLDER_EXAMPLE',
        );
      }
    });
    this.querySearch('');
  }

  public querySearch(query): void {
    this.selectedFlight = null;
    this.searchData.flightNumber = null;
    this.searchData.flightsFiltered = cloneDeep(this.searchData.flights);
    if (!query || query.trim().length === 0) {
      this.searchData.flightsFiltered = cloneDeep(this.searchData.flights);
    } else {
      query = query.toLowerCase();
      this.searchData.flightsFiltered = cloneDeep(
        this.searchData.flights.filter(flight => {
          const dataToFind = flight.flightNumber.toLowerCase();
          if (dataToFind.includes(query)) {
            return flight;
          }
        }),
      );
    }
  }

  public isFastTyping() {
    return this.oclOptions.getFastTypingModal();
  }

  public resetFlight(): void {
    this.selectedFlight = null;
    this.searchData = {
      date: undefined,
      flights: [],
      flightsFiltered: [],
      flightNumber: null,
    };
  }

  // Seem to be unused
  // public eventOnChanged(): void {
  //   if (this.selectedItem && this.selectedItem.tags) {
  //     this.selectedTags = this.selectedItem.tags;
  //   }
  // }

  public selectedItemChange(value: { option: { value: string } }): void {
    this.selectedFlight = this.searchData.flights.find(f => f.objectId === value.option.value);
    this.searchData.flightNumber = this.selectedFlight.flightNumber;
  }

  public cancel(): void {
    this.loading = false;
    this.dialogRef.close();
  }

  addEvent(event, applicability = null): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(this.eventModal, {
      data: {
        notifications: this.notifications,
        fromDecision: {
          attachments: this.decision.attachments,
          tags: this.decision.tags,
          message: this.decision.contentText,
          applicability: applicability,
          acl: this.decision.acl,
        },
        fromLogbook: undefined,
        isUtc: this.isUtc,
        airportsCode: this.airportsCode,
      },
    });
    dialogRef
      .afterClosed()
      .toPromise()
      .then(newEvent => {
        if (newEvent) {
          const bufferEvent = cloneDeep(newEvent);
          this.events.push(bufferEvent);
          this.linkedEvents.push(bufferEvent.objectId);
          this.linkedEventsDisplay.push(bufferEvent);
        }
      });
  }

  public changelinkedEvent(selectedValues) {
    this.linkedEventsDisplay = [...intersectionWith(this.events, selectedValues, (i, j) => i.objectId === j), ...this.linkedEventsArchived];
  }

  public removeEvent(ev): void {
    this.linkedEvents = this.linkedEvents.filter(event => event !== ev.objectId);
    this.linkedEventsDisplay = this.linkedEventsDisplay.filter(event => event.objectId !== ev.objectId);
  }

  public updateLinkedGroup(e) {
    this.linkedGroup = e;
  }

  public addLogbook(event, applicability = null): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(this.occLogbookModal, {
      data: {
        events: this.events,
        isUtc: !this.moduleConfig.config.localHours,
        logbook: null,
        fromDecision: {
          attachments: this.decision.attachments,
          tags: this.decision.tags,
          message: this.decision.contentText,
          flight: this.selectedFlight,
          applicability: applicability,
          acl: this.decision.acl,
        },
        airportsCode: this.airportsCode,
      },
    });
    dialogRef.afterClosed().subscribe(newLogbook => {
      if (newLogbook) {
        const bufferLogbook = cloneDeep(newLogbook);
        this.logBookItems.push(bufferLogbook);
        this.linkedLogBooks.push(bufferLogbook.objectId);
        this.linkedLogBooksDisplay.push(bufferLogbook);
      }
    });
  }

  public removeLogBook(lgb): void {
    this.linkedLogBooks = this.linkedLogBooks.filter(logBook => logBook !== lgb.objectId);
    this.linkedLogBooksDisplay = this.linkedLogBooksDisplay.filter(logBook => logBook.objectId !== lgb.objectId);
  }

  public changelinkedLogBook(selectedValues) {
    this.linkedLogBooksDisplay = [
      ...intersectionWith(this.logBookItems, selectedValues, (i, j) => i.objectId === j),
      ...this.linkedLogBookArchived,
    ];
  }

  public saveDecision(
    event: {
      contentTextChanged?: boolean;
      notifications?: HolNotification[];
      nextInfo?: nextInfoType;
      notifyFunction?: HolNotifyFunction;
    },
    closeModal: boolean = true,
  ): void {
    if (this.decision.erpDecision && !this.fromERP) {
      this.deleteErpDecision();
    }
    this.decision.nextInfoTime = event.nextInfo && event.nextInfo.nextInfoTime ? event.nextInfo.nextInfoTime : undefined;
    //  this.decision.done = event.nextInfo && event.nextInfo.nextInfoDone ? event.nextInfo.nextInfoDone : false;
    if (this.decision.isTodo) {
      if (event && event.nextInfo) {
        this.decision.done =
          !!this.initialNIdone && !moment(this.initialNIvalue).isSame(this.decision.nextInfoTime) ? false : event.nextInfo.nextInfoDone;
        this.saveEntity(event, closeModal);
      }
    } else {
      this.saveEntity(event, closeModal);
    }
  }

  deleteErpDecision(): void {
    this.decisionsService.deleteErpDecision(this.decision);
    this.dialogRef.close();
  }

  public toggleIsTodo($event): void {
    if (!this.isCreate) {
      // transform Decision to Todo entity (and clear applicabilities)
      if (!this.decision.isTodo) {
        const mod = this.dialog
          .open(ConfirmationModalComponent, {
            data: {
              modalTitle: this.translatePipe.transform(
                this.moduleConfig.config.translateKey + '.MODALS.DECISION.CONVERT_DECISION_TO_TODO.TITLE',
              ),
              modalContent: this.translatePipe.transform(
                this.moduleConfig.config.translateKey + '.MODALS.DECISION.CONVERT_DECISION_TO_TODO.CONTENT',
              ),
              modalQuestion: this.translatePipe.transform(
                this.moduleConfig.config.translateKey + '.MODALS.DECISION.CONVERT_DECISION_TO_TODO.QUESTION',
              ),
            },
          })
          .afterClosed()
          .toPromise()
          .then(confirm => {
            if (confirm) {
              if (this.decision instanceof FltDecision) {
                this.decision.applicability = new FltApplicability();
              } else {
                this.resetFlight();
              }
              this.loading = true;
              this.decision.isTodo = true;
              this.nextInfo = {
                nextInfoTime: this.decision.nextInfoTime,
                nextInfoDone: this.decision.done,
              };
              // this.saveDecision({ contentTextChanged: false, notifications: null, nextInfo: this.nextInfo }, false);
            } else {
              this.decision.isTodo = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.nextInfo = {
          nextInfoTime: this.decision.nextInfoTime,
          nextInfoDone: this.decision.done,
        };
        // this.saveDecision(null, false);
      }
    } else {
      // creation of Todo entity (but entity created by save button)
      this.decision.isTodo = true;
    }
  }

  ngOnDestroy() {
    this.hasCrisisInProgressSub.unsubscribe();
    this.config$.unsubscribe();

    const date = moment().subtract(1, 'hours').toDate();
    this.groupService.fetchNewDataDecisionGroup(date).then(r => {});
  }

  async saveSummary(savedDecision: OclDecision, isInBriefing: boolean, isInSummary?: boolean): Promise<void> {
    return;
  }

  public onChangeHolModalConfig(config: HolModalConfig) {
    if (config.transfertToERP) {
      if (!this.decision.fromERP) {
        this.toERP = config.transfertToERP;
        this.decision.toERP = config.transfertToERP;
      } else {
        this.config.transfertToERP = false;
        this.config$.next(this.config);
      }
      // this.saveLogbook({contentTextChanged: false, notifications: config.notifications});
    } else if (config.transfertToLogbook) {
      this.changeToLogbook = true;
      this.saveDecision({ contentTextChanged: false, notifications: config.notifications, nextInfo: null }, true);
    } else {
      this.isInSummary = config.isOnSummary;
    }
  }

  protected updateGroupSelected(decision?: OclDecision): Promise<any>[] {
    const listGroupPromise = [];
    // First we remove this item from all groups & then we add the item to the list of groups.
    this.decisionGroup.forEach(lgr => {
      if (this.data.decision) lgr.items = lgr.items.filter(lg => lg.objectId !== this.data.decision.objectId);
      if (this.linkedGroup.includes(lgr.objectId)) {
        if (decision) {
          lgr.items.push(decision);
        } else {
          lgr.items.push(this.data.decision);
        }
      }
      listGroupPromise.push(this.groupService.save(lgr, 'DECISION'));
    });

    return listGroupPromise;
  }

  private saveEntity(
    event: {
      contentTextChanged?: boolean;
      notifications?: HolNotification[];
      nextInfo?: nextInfoType;
      notifyFunction?: HolNotifyFunction;
    },
    closeModal: boolean = true,
  ) {
    this.loading = true;
    const { notifications } = event;
    if (this.isCreate) {
      this.decision.message = this.decision.contentText;
      this.decision.event = this.selectedItem;
      this.decision.flight = this.selectedFlight;
      if (this.moduleConfig.config.displayToGoc) {
        const toGOCValue = this.selectedFlight ? true : false;
        this.decision.toGOC = toGOCValue;
        this.duplicateToOtherModule = toGOCValue;
      }
      if (this.moduleConfig.config.displayToERP) {
        this.duplicateToOtherModule = this.toERP;
        this.decision.toERP = this.toERP;
      }

      this.decisionsService
        .create(this.decision, notifications, this.context, this.duplicateToOtherModule)
        .then(async newDecision => {
          if (this.isInSummary) {
            await this.saveSummary(newDecision, this.isInBriefing, this.isInSummary);
          }
          Promise.all([
            this.linksService.saveLinkDecisionEvent(newDecision.objectId, this.linkedEvents),
            this.linksService.saveLinkLogBookDecision(newDecision.objectId, 'decision', this.linkedLogBooks),
            this.updateGroupSelected(newDecision),
          ])
            .then(() => {
              this.linksService
                .checkLinks([newDecision.objectId], this.linkedLogBooks, this.linkedEvents, true)
                .then(linkIds => {
                  this.occLinkItemsStoreManager.updateLinkedItems(linkIds);
                  this.dialogRef.close(newDecision);
                })
                .catch(error => {
                  this.dialogRef.close();
                  console.error('Error creating Decision link', error);
                })
                .finally(() => {
                  // use moment for Date - 1 hours
                  const date = moment().subtract(1, 'hours').toDate();
                  this.groupService.fetchNewDataDecisionGroup(date);
                  this.loading = false;
                  this.dialogRef.close();
                });
            })
            .catch(error => {
              this.dialogRef.close();
              console.error('Error creating Decision link', error);
            });
        })
        .catch(error => {
          this.dialogRef.close();
          console.error('Error creating OCCStatusDecision', error);
        })
        .finally(() => {
          this.dialogRef.close();
        });
    } else {
      let isModalNeed = false;

      if (event && event.contentTextChanged) {
        if (this.holOptionsService.isDefaultTimeMinuteForChangeCustomCreateDate()) {
          const defaultTime = this.holOptionsService.getDefaultTimeMinuteForChangeCustomCreateDate();
          if (defaultTime) {
            const now = new Date();
            const defaultMinutesAgo = new Date(now.getTime() - defaultTime * 60000); // 60000 ms = 1 minute

            if (this.data.decision.createdAt < defaultMinutesAgo) {
              isModalNeed = true;
            }
          }
        }
      }

      if (isModalNeed) {
        const timeDialog = this.dialog.open(ConfirmationModalComponent, {
          data: {
            modalTitle: this.translatePipe.transform('COMMON.MODALS.DATE_CHANGE.TITLE'),
            modalContent: this.translatePipe.transform('COMMON.MODALS.DATE_CHANGE.CONTENT'),
            modalQuestion: this.translatePipe.transform('COMMON.MODALS.DATE_CHANGE.QUESTION'),
          },
        });
        timeDialog.afterClosed().subscribe(value => {
          if (value) {
            this.decision.customCreatedAt = new Date();
          }
          this.saveOnBase(event, closeModal);
        });
      } else {
        this.saveOnBase(event, closeModal);
      }
    }
  }

  private saveOnBase(
    event: {
      contentTextChanged?: boolean;
      notifications?: HolNotification[];
      nextInfo?: nextInfoType;
      holNotifyFunction?: HolNotifyFunction;
    },
    closeModal: boolean = true,
  ) {
    this.decision.flight = this.selectedFlight;
    if (event && event.contentTextChanged) {
      this.decision.message = this.decision.contentText;
      //   this.decision.customCreatedAt = new Date();
    }
    if (this.moduleConfig.config.displayToERP) {
      this.oldDuplicateToOtherModuleValue = this.decision.toERP;
      this.newDuplicateToOtherModuleValue = this.toERP;
      this.duplicateToOtherModule = this.toERP;
      this.decision.toERP = this.toERP;
    }

    const linkedEventsToUpdate = difference(this.linkedEvents, this.linkedEventsCopy);
    const linkedEventsToDelete = difference(this.linkedEventsCopy, this.linkedEvents);

    const linkedLogBooksToUpdate = difference(this.linkedLogBooks, this.linkedLogBooksCopy);
    const linkedLogBooksToDelete = difference(this.linkedLogBooksCopy, this.linkedLogBooks);

    if (this.changeToLogbook) {
      this.oclLogbookDecisionService
        .transformDecisionToLogbook(this.decision, event.notifications, this.context)
        .catch(e => {
          console.error(e);
        })
        .finally(async () => {
          this.loading = false;
          this.dialogRef.close();
          await this.groupService.fetchNewDataDecisionGroup();
        });
      return;
    }

    this.decisionsService
      .update(this.decision, event.notifications, this.context, this.oldDuplicateToOtherModuleValue, this.newDuplicateToOtherModuleValue)
      .then(async newDecision => {
        await this.saveSummary(newDecision, this.isInBriefing, this.isInSummary);
        // STORE
        // const decisonTemp = new OclDecision(newDecision);
        const decisonTemp = cloneDeep(newDecision);
        decisonTemp.tags = this.decision.tags;
        this.occDecisionsStoreManager.updateOneDecision(decisonTemp);

        Promise.all([
          this.linksService.saveLinkDecisionEvent(this.decision.objectId, linkedEventsToUpdate),
          this.linksService.saveLinkLogBookDecision(this.decision.objectId, 'decision', linkedLogBooksToUpdate),
          this.linksService.deleteLinkDecisionEventById(this.decision.objectId, linkedEventsToDelete),
          this.linksService.deleteLinkLogBookForDecisionById(this.decision.objectId, linkedLogBooksToDelete),
          this.updateGroupSelected(),
        ])
          .then(() => {
            try {
              this.linksService
                .checkLinks([], [], [], true)
                .then(linkIds => {
                  this.occLinkItemsStoreManager.updateLinkedItems(linkIds);
                  if (closeModal) {
                    this.dialogRef.close(newDecision);
                  }
                })
                .catch(error => {
                  if (closeModal) {
                    this.dialogRef.close();
                  }
                  console.error('Error creating Decision link', error);
                })
                .finally(() => {
                  this.groupService.fetchNewDataDecisionGroup();
                  this.loading = false;
                  this.dialogRef.close();
                });
            } catch (e) {
              console.error(e);
              this.loading = false;
              this.dialogRef.close();
            }
          })
          .catch(error => {
            console.error(error);
            if (closeModal) {
              this.dialogRef.close();
            }
          });
      })
      .catch(error => {
        console.error(error);
        if (closeModal) {
          this.dialogRef.close();
        }
      })
      .finally(() => {
        this.dialogRef.close();
      });
  }
}
